(function(){
const EN = !!(window.KQ&&window.KQ.en);
const PRE = ((window.KQ&&window.KQ.pre)||'/').replace(/\/$/,'');
const L = EN ? {
  vraag:function(n,t){return 'Question '+n+' of '+t},
  msgs:['Analysing skin type…','Matching products…','Building your routine…'],
  olie:' · Oil cleanse', reinig:' · Cleanse', hydrateer:' · Hydrate',
  behandel:' · Treat', verzorg:' · Nourish', bescherm:' · Protect', verwen:' · Pamper',
  titles:{glow:'Glow & an even tone',kalm:'Calm & comfortable',puist:'Clear & balanced',aging:'Firm & radiant',hydra:'Deeply hydrated'},
  skin:{droog:'Dry skin',vet:'Oily skin',gecombineerd:'Combination skin',normaal:'Normal skin'},
  fallback:'Your routine', gevoelig:'Sensitive',
  kort:'Simple routine', lang:'Extended routine',
  bezig:'Adding…', klaar:'✓ Added', knop:'Add the complete routine',
  gift:'✓ Includes free shipping and your free gift', ship:'✓ Includes free shipping',
  fout:'Something went wrong, please try again or add the products separately.'
} : {
  vraag:function(n,t){return 'Vraag '+n+' van '+t},
  msgs:['Huidtype analyseren…','Producten matchen…','Routine samenstellen…'],
  olie:' · Reinig met olie', reinig:' · Reinig', hydrateer:' · Hydrateer',
  behandel:' · Behandel', verzorg:' · Verzorg', bescherm:' · Bescherm', verwen:' · Verwen',
  titles:{glow:'Glow & een egale teint',kalm:'Kalm & comfortabel',puist:'Helder & in balans',aging:'Stevig & stralend',hydra:'Diep gehydrateerd'},
  skin:{droog:'Droge huid',vet:'Vette huid',gecombineerd:'Gecombineerde huid',normaal:'Normale huid'},
  fallback:'Jouw routine', gevoelig:'Gevoelig',
  kort:'Simpele routine', lang:'Uitgebreide routine',
  bezig:'Toevoegen…', klaar:'✓ Toegevoegd', knop:'Voeg complete routine toe',
  gift:'✓ Inclusief gratis verzending én je gratis cadeau', ship:'✓ Inclusief gratis verzending',
  fout:'Er ging iets mis, probeer het nog eens of voeg de producten los toe.'
};
const P={
 marula:{b:'SUPPURU',n:'Marula Zuiverende Reinigingsolie',ne:'Marula Purifying Cleansing Oil',p:25.00,w:'Lost SPF en talg op, de eerste stap van dubbel reinigen',we:'Dissolves SPF and sebum, step one of a double cleanse',u:'/products/marula-zuiverende-reinigingsolie-200ml',v:47367168131310,i:'https://cdn.shopify.com/s/files/1/0784/7837/7198/files/204A2424.jpg?v=1765012309'},
 avocado:{b:'SUPPURU',n:'Avocado Milde Diepreinigende Foam',ne:'Avocado Gentle Deep Cleansing Foam',p:17.00,w:'Milde foam die diep reinigt zonder uit te drogen',we:'Gentle foam that cleans deep without drying out',u:'/products/avocado-milde-diepreinigende-foam-150ml',v:47367168098542,i:'https://cdn.shopify.com/s/files/1/0784/7837/7198/files/204A2403.jpg?v=1765013001'},
 toner:{b:'SUPPURU',n:'Balancerende Toner',ne:'Balancing Toner',p:22.00,w:'Brengt je huid in balans met niacinamide en centella',we:'Balances your skin with niacinamide and centella',u:'/products/balancerende-toner-150ml',v:47367167934702,i:'https://cdn.shopify.com/s/files/1/0784/7837/7198/files/suppuru-balancing-toner.webp?v=1787081568'},
 verhelderend:{b:'SUPPURU',n:'Verhelderend Serum',ne:'Brightening Serum',p:19.00,w:'Egaliseert de teint en geeft je glow terug',we:'Evens out the tone and brings back your glow',u:'/products/verhelderend-serum-30ml',v:47367167967470,i:'https://cdn.shopify.com/s/files/1/0784/7837/7198/files/suppuru-brightening-serum.webp?v=1787081586'},
 cica:{b:'SUPPURU',n:'Cica-PDRN Vitaliserend Serum',ne:'Cica-PDRN Vitalizing Serum',p:27.95,w:'PDRN en centella voor een kalme, verzorgde huid',we:'PDRN and centella for calm, cared-for skin',u:'/products/suppuru-cica-pdrn-vitaliserend-serum-30ml',v:48233886875886,i:'https://cdn.shopify.com/s/files/1/0784/7837/7198/files/cica-pdrn-packshot-v5.webp?v=1787169833'},
 creme:{b:'SUPPURU',n:'Kalmerende Crème',ne:'Calming Cream',p:25.00,w:'Verzorgt de gevoelige huid en sluit je routine zacht af',we:'Cares for sensitive skin and seals your routine softly',u:'/products/kalmerende-creme-50g',v:47367168000238,i:'https://cdn.shopify.com/s/files/1/0784/7837/7198/files/204A1604-2_80fe2352-a906-49e9-b6ae-3bf4d27df15b.jpg?v=1765035772'},
 spf:{b:'SUPPURU',n:'360° Zonnebrandcrème',ne:'360° Sunscreen',p:18.00,w:'Lichte SPF50+ zonder witte waas, elke dag',we:'Light SPF50+ with no white cast, every day',u:'/products/360-zonnebrandcreme-50ml',v:47367168033006,i:'https://cdn.shopify.com/s/files/1/0784/7837/7198/files/suppuru-360-sunscreen.webp?v=1787081592'},
 masker:{b:'SUPPURU',n:'Verjongend Gezichtsmasker',ne:'Rejuvenating Face Mask',p:5.00,w:'Een verwenmoment, 1 à 2 keer per week',we:'A treat, once or twice a week',u:'/products/verjongend-gezichtsmasker-26g',v:47367168065774,i:'https://cdn.shopify.com/s/files/1/0784/7837/7198/files/suppuru-face-mask.webp?v=1787081595'}
};
const a={};let cur=1;const TOTAL=4;let routine=[];
window.kqA=function(step,val,el){
  a[step]=val;
  el.parentElement.querySelectorAll('.kq__opt').forEach(o=>o.classList.remove('kq--sel'));
  el.classList.add('kq--sel');
  setTimeout(()=>{cur=step+1;cur>TOTAL?finish():show(cur)},320);
};
function show(n){
  document.querySelectorAll('.kq__step').forEach(s=>s.classList.remove('kq--active'));
  document.querySelector('[data-kqstep="'+n+'"]').classList.add('kq--active');
  document.getElementById('kqStepLabel').textContent=L.vraag(n,TOTAL);
  document.getElementById('kqFill').style.width=(n/TOTAL*100)+'%';
  document.getElementById('kqNav').style.display=n>1?'block':'none';
  window.scrollTo({top:0,behavior:'smooth'});
}
window.kqBack=function(){if(cur>1){cur--;show(cur)}};
function finish(){
  document.querySelectorAll('.kq__step').forEach(s=>s.classList.remove('kq--active'));
  document.querySelector('[data-kqstep="loading"]').classList.add('kq--active');
  document.getElementById('kqNav').style.display='none';
  document.getElementById('kqProgress').style.display='none';
  const msgs=L.msgs;let i=0;
  const iv=setInterval(()=>{i++;if(i<msgs.length)document.getElementById('kqLoadMsg').textContent=msgs[i]},600);
  setTimeout(()=>{clearInterval(iv);result()},1900);
}
function STAP(n){return (EN?'Step ':'Stap ')+n}
function pick(){
  const goal=a[2],len=a[4];
  const uitgebreid=len==='uitgebreid';
  const serum=(goal==='glow'||goal==='puist')?P.verhelderend:P.cica;
  const steps=[];
  if(uitgebreid)steps.push([L.olie,P.marula]);
  steps.push([L.reinig,P.avocado]);
  if(uitgebreid)steps.push([L.hydrateer,P.toner]);
  steps.push([L.behandel,serum]);
  steps.push([L.verzorg,P.creme]);
  steps.push([L.bescherm,P.spf]);
  if(uitgebreid)steps.push([L.verwen,P.masker]);
  return steps.map(function(s,i){return [STAP(i+1)+s[0],s[1]]});
}
const TITLES=L.titles;
const SKIN=L.skin;
function result(){
  routine=pick();
  document.getElementById('kqTitle').textContent=TITLES[a[2]]||L.fallback;
  const pills=[SKIN[a[1]]];if(a[3]==='ja')pills.push(L.gevoelig);
  pills.push(a[4]==='kort'?L.kort:L.lang);
  document.getElementById('kqPills').innerHTML=pills.map(p=>'<span class="kq__pill">'+p+'</span>').join('');
  let total=0,html='';
  routine.forEach(function(s){const tag=s[0],p=s[1];total+=p.p;
    const naam=(EN&&p.ne)?p.ne:p.n;
    html+='<a class="kq__rp" href="'+PRE+p.u+'"><span class="kq__rtag">'+tag+'</span>'+
      '<span class="kq__rimg"><img src="'+p.i+'" alt="'+naam+'" loading="lazy"></span>'+
      '<span class="kq__rinfo"><span class="kq__rbrand">'+p.b+'</span>'+
      '<span class="kq__rname" style="display:block">'+naam+'</span><span class="kq__rwhy">→ '+(EN&&p.we?p.we:p.w)+'</span></span>'+
      '<span class="kq__rprice">€'+p.p.toFixed(2).replace('.',',')+'</span></a>';
  });
  document.getElementById('kqList').innerHTML=html;
  document.getElementById('kqTotal').textContent='€'+total.toFixed(2).replace('.',',');
  document.getElementById('kqNote').textContent=total>=50?L.gift:L.ship;
  document.querySelector('[data-kqstep="loading"]').classList.remove('kq--active');
  document.getElementById('kqResult').classList.add('kq--active');
  window.scrollTo({top:0,behavior:'smooth'});
}
window.kqAddAll=function(){
  const btn=document.getElementById('kqAddBtn');
  btn.disabled=true;btn.textContent=L.bezig;
  const items=routine.map(function(s){return{id:s[1].v,quantity:1}});
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
  .then(function(r){if(!r.ok)throw new Error('cart');return r.json()})
  .then(function(){btn.textContent=L.klaar;setTimeout(function(){window.location.href=PRE+'/cart'},600)})
  .catch(function(){btn.disabled=false;btn.textContent=L.knop;alert(L.fout)});
};
})();